export enum IdnowCustomError {
  RESIDENCE_PERMIT_DOES_NOT_ALLOW_WORKING_IN_FRANCE = 'Residence permit does not allow working in France',
}
